export default __webpack_public_path__ + "static/media/in_store_gg.ebf004d7.svg";